import { IonModal } from '@ionic/react';
import React from 'react';

import { close } from 'ionicons/icons';

import Navigation from '../../../components/UI/Navigation';
import './Modal.scss';
import { ModalProps } from './types';

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  navigation = true,
  navTitle,
  dismissible = true,
}) => {
  return (
    <div className="modal">
      <IonModal
        isOpen={isOpen}
        onDidDismiss={onClose}
        swipeToClose={dismissible}
        backdropDismiss={dismissible}
        animated={false}
        cssClass="desktop-fullscreen-modal"
      >
        <div className="modal__content">
          {navigation && (
            <Navigation startIcon={close} onBack={onClose} title={navTitle} />
          )}
          {children}
        </div>
      </IonModal>
    </div>
  );
};

export default React.memo(Modal);
